//tslint:disable

import React, { useEffect, useState } from "react";
import { Editor } from '@tinymce/tinymce-react';
import axios from "axios";

const DragAndDropImage = ({ course, topic, lesson, dragDropInfo, edit }) => {
  const [isError, setError] = useState(false);
  const [isErrorImage, setErrorImage] = useState(false);
  const [isErrorPriority, setErrorPriority] = useState(false);
  const [kind, setKind] = useState('value_sorting');
  const [question, setQuestion] = useState(dragDropInfo ? dragDropInfo.question : '');
  const [explanation, setExplanation] = useState(dragDropInfo ? dragDropInfo.explanation : '');
  const [tip, setTip] = useState(dragDropInfo ? dragDropInfo.tip : '');
  const [priority, setPriority] = useState(dragDropInfo ? dragDropInfo.priority : '');
  const [difficulty, setDifficulty] = useState(dragDropInfo ? dragDropInfo.difficulty : '');
  const [imageList, setImageList] = useState(dragDropInfo ? dragDropInfo.variants.image : []);
  const [imageList2, setImageList2] = useState(dragDropInfo ? dragDropInfo.variants.image2 : []);
  const [titleBlock1, setTitleBlock1] = useState(dragDropInfo ? dragDropInfo.variants.title1 : []);
  const [titleBlock2, setTitleBlock2] = useState(dragDropInfo ? dragDropInfo.variants.title2 : []);

  const handleSubmit = (ev) => {
    ev.preventDefault();
    const result = {
      course_drag_and_drop: {
        kind,
        variants: {
          image: imageList,
          image2: imageList2,
          title1: titleBlock1,
          title2: titleBlock2,
        },
        question,
        explanation,
        tip,
        difficulty,
        priority
      }
    }

    if (question === '' ||
        difficulty === '' ||
        imageList.length === 0 ||
        imageList2.length === 0 ||
        titleBlock1 === '' ||
        titleBlock2 === '' ||
        priority === ''
    ) {
      setError(true);
    } else {
      setError(false);
    }

    if (!(imageList.length + imageList2.length >= 4 && imageList.length + imageList2.length <=6)) {
      setErrorImage(true);
    } else {
      setErrorImage(false);
    }

    if (question !== '' &&
        difficulty !== '' &&
        imageList.length !== 0 &&
        imageList2.length !== 0 &&
        titleBlock1 !== '' &&
        titleBlock2 !== '' &&
        priority !== '' &&
        imageList.length + imageList2.length >= 4 && imageList.length + imageList2.length <=6
    ) {
      if (edit) {
        axios
          .patch(
            `/backend/admin/courses/${course.id}/topics/${topic.id}/lessons/${lesson.id}/drag_and_drops/${dragDropInfo.id}`,
            result,
            {
              headers: {
                'Content-Type': 'application/json',
                'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
              },
            }
          ).then(() => {
            location.href = `/backend/admin/courses/${course.id}/topics/${topic.id}/lessons/${lesson.id}#drag_and_drops`
          })
          .catch((e) => {
            if (e.response.data.priority[0] === 'уже существует') {
              setErrorPriority(true)
            }
          });
      } else {
        axios
          .post(
            `/backend/admin/courses/${course.id}/topics/${topic.id}/lessons/${lesson.id}/drag_and_drops`,
            result,
            {
              headers: {
                'Content-Type': 'application/json',
                'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
              },
            }
          ).then(() => {
            location.href = `/backend/admin/courses/${course.id}/topics/${topic.id}/lessons/${lesson.id}#drag_and_drops`
          })
          .catch((e) => {
            if (e.response.data.priority[0] === 'уже существует') {
              setErrorPriority(true)
            }
          });
      }
    }
  };

  const uploadImage = (data, type) => {
    axios.post('/backend/api/admin/v1/uploaded_files', data,
      {
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        },
      }).then((result) => {
        if (type === 1) {
          setImageList([...imageList, result.data]);
        }
        if (type === 2) {
          setImageList2([...imageList2, result.data]);
        }
      })
      .catch((e) => {
        console.log(e)
      });
  }

  const handleImageChange = (event, type) => {
    event.preventDefault();
    const target = event.target;
    const reader = new FileReader();
    const formData = new FormData();

    if (target.files.length) {
      if (!['image/png', 'image/jpeg', 'image/jpg'].includes(target.files[0].type)) {
        alert('Недопустимое расширение файла');
        target.value = '';
        return;
      }
      if (target.files[0].size > 5000000) {
        alert('Файл слишком большой');
        target.value = '';
        return;
      }
      reader.readAsDataURL(target.files[0]);
    }

    reader.onload = (e) => {
      const image = new Image();

      image.src = e.target.result;

      image.onload = () => {
        if (image.width < 150 && image.height < 150) {
          alert('Разрешение слишком маленькое');
          target.value = '';
          return;
        }
        if (target.files.length) {
          if (type === 1) {
            formData.append('file', target.files[0]);
            uploadImage(formData, 1);
          }
          if (type === 2) {
            formData.append('file', target.files[0]);
            uploadImage(formData, 2);
          }
        }
      };
    };
  }

  const deleteImage = (item, type) => {
    const arr = type === 1 ? [...imageList] : [...imageList2];

    const indexResult = arr.findIndex((image) => image.id === item.id)

    arr.splice(indexResult, 1);

    axios.delete(`/backend/api/admin/v1/uploaded_files/${item.id}`,
      {
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        },
      }).then(() => {
        if (type === 1) {
          setImageList(arr)
        } else {
          setImageList2(arr)
        }
      })
      .catch((e) => {
        console.log(e)
      });
  }

  return (
    <form className="modal-form" onSubmit={handleSubmit} style={{ marginTop: '20px' }}>
      <div className="form-group string required">
        <label className="control-label string required" htmlFor="question">
          <abbr title="required">*</abbr>
            Вопрос
        </label>
        <Editor
          apiKey='kxcwvdfzs45kp41l80l8lqp32lhery31i1sqi88mjxynx1ur'
          onEditorChange={(e => setQuestion(e))}
          value={question}
          init={{
            height: 200,
            menubar: true,
            toolbar: 'undo redo | formatselect | ' +
            'bold italic backcolor | alignleft aligncenter ' +
            'alignright alignjustify | bullist numlist outdent indent | ' +
            'removeformat | help',
            content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
          }}
        />
      </div>
      <div className="form-group text">
        <label className="control-label text" htmlFor="tip">
          Подсказка
        </label>
        <textarea className="form-control text" defaultValue={tip} onChange={(e) => setTip(e.target.value)} id="tip" />
      </div>
      <div className="form-group text">
        <label className="control-label text" htmlFor="explanation">
          Решение
        </label>
        <Editor
          apiKey='kxcwvdfzs45kp41l80l8lqp32lhery31i1sqi88mjxynx1ur'
          onEditorChange={(e => setExplanation(e))}
          value={explanation}
          init={{
            height: 200,
            menubar: true,
            toolbar: 'undo redo | formatselect | ' +
            'bold italic backcolor | alignleft aligncenter ' +
            'alignright alignjustify | bullist numlist outdent indent | ' +
            'removeformat | help',
            content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
          }}
        />
      </div>
      <div className="form-group text">
        <label className="control-label text" htmlFor="priority">
          <abbr title="required">*</abbr>
          Приоритет
        </label>
        <input className="form-control text" type={'number'} defaultValue={priority} onChange={(e) => {setPriority(e.target.value);setErrorPriority(false);}} id="priority" />
      </div>
      <div className="form-group select">
        <label className="control-label select" htmlFor="difficulty">
          <abbr title="required">*</abbr>
          Сложность
        </label>
        <select className="form-control select" defaultValue={difficulty} onChange={(e) => setDifficulty(e.target.value)} id="difficulty">
          <option selected value=""></option>
          <option value="1">1</option>
          <option value="2">2</option>
          <option value="3">3</option>
        </select>
      </div>

      <div className="row">
        <div className="col">
          <div className="form-group integer">
            <label className="control-label integer" htmlFor="addWord">
              <abbr title="required">*</abbr>
              Название 1 блока
            </label>
            <input
              className="form-control numeric integer"
              type={'text'}
              id="addWord"
              maxLength={20}
              defaultValue={titleBlock1}
              onInput={(e) => setTitleBlock1(e.target.value)}
            />
          </div>
        </div>
      </div>

      <div style={{ marginBottom: '30px'}}>
        Добавить картинку
        <input 
          id='avatar'
          type='file'
          accept='.jpeg, .jpg, .png'
          onChange={(e) => handleImageChange(e,1)}
        />
      </div>

      <div style={{display: "flex"}}>
        {imageList.map(item => {
          return (
            <div style={{marginRight: "12px", position: 'relative'}} key={item.id}>
              <img src={item.url} width={130} height={130} />
              <span className='itemDelete' onClick={() => deleteImage(item, 1)} />
            </div>
          )
        })}
      </div>

      <div className="row">
        <div className="col">
          <div className="form-group integer">
            <label className="control-label integer" htmlFor="addWord">
              <abbr title="required">*</abbr>
              Название 2 блока
            </label>
            <input
              className="form-control numeric integer"
              type={'text'}
              id="addWord"
              maxLength={20}
              defaultValue={titleBlock2}
              onInput={(e) => setTitleBlock2(e.target.value)}
            />
          </div>
        </div>
      </div>

      <div style={{ marginBottom: '30px'}}>
        Добавить картинку
        <input 
          id='avatar'
          type='file'
          accept='.jpeg, .jpg, .png'
          onChange={(e) => handleImageChange(e,2)}
        />
      </div>

      <div style={{display: "flex"}}>
        {imageList2.map(item => {
          return (
            <div style={{marginRight: "12px", position: 'relative'}} key={item.id}>
              <img src={item.url} width={130} height={130} />
              <span className='itemDelete' onClick={() => deleteImage(item, 2)} />
            </div>
          )
        })}
      </div>

      {isError && <div className="error">Заполните все обязательные поля</div>}
      {isErrorImage && <div className="error">Количество загружаемых изображений: не менее 4 и не более 6</div>}
      {isErrorPriority && <div className="error">Приоритет с таким значением уже существует</div>}
      <button type="submit" className="btn btn-default mtl-2 btn btn-outline-success">
        Отправить
      </button>
    </form>
  );
}

export default React.memo(DragAndDropImage);


// WEBPACK FOOTER //
// ./app/frontend/components/DragAndDropImage.js